import { gql } from '@apollo/client'
import { ArrowRightIcon, BodyText, Button, Heading } from '@farol-ds/react'
import classNames from 'classnames'

import { BenefitsList } from '../benefits-list'
import { DoctrineUnloggedLockContent_OfferLockDataFragment } from './__generated__/doctrine-unlogged-lock-content.graphql'
import styles from './doctrine-unlogged-lock-content.module.scss'

export interface DoctrineUnloggedLockContentProps {
  isPaywall: boolean
  offerLockData: DoctrineUnloggedLockContent_OfferLockDataFragment
}

export function DoctrineUnloggedLockContent({
  offerLockData,
  isPaywall,
}: DoctrineUnloggedLockContentProps) {
  const { body, header } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const card = body?.cards?.[0]

  if (!card) return null

  return (
    <>
      <div className={classNames(styles.header, { [styles.paywall]: isPaywall })}>
        <Heading size="lg">{title}</Heading>
        <BodyText size="md">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>

      <div className={classNames(styles.card, { [styles.paywall]: isPaywall })}>
        <BenefitsList offerLockCard={card} />

        <div className={styles.buttons}>
          {card.buttons.map((button, index) => (
            <Button
              key={index}
              kind={button.kind || 'primary'}
              rightIcon={index === card.buttons.length - 1 ? <ArrowRightIcon /> : undefined}
              asChild={!!button.url}
            >
              {button.url ? (
                <a href={button.url} target={index > 0 ? '_blank' : ''} rel="noopener noreferrer">
                  {button.label}
                </a>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
    </>
  )
}

DoctrineUnloggedLockContent.fragments = {
  offerLockData: gql`
    fragment DoctrineUnloggedLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          buttons {
            label
            kind
            url
          }
          ...BenefitsList_offerLockCard
        }
      }
    }
    ${BenefitsList.fragments.offerLockCard}
  `,
}
